// extracted by mini-css-extract-plugin
export default {"container":"T02_eco_container__TfhWF","section":"T02_eco_section__2owxa","limiter":"T02_eco_limiter__SVRdw","text":"T02_eco_text__ryWcC"};